// extracted by mini-css-extract-plugin
export default {"sendButtonContainer":"MonitoringForm_sendButtonContainer__f6ZOl","buttonStart":"MonitoringForm_buttonStart__MtySy"};